import AreaContainer from "../AreaContainer";
import globalStyles from '../result.module.css';
import styles from './moreInfo.module.css';

type Props = {
    website: string
}

const MoreInfo = ({ website }: Props) => {
    if (!website) {
        return null;
    }
    return (
        <AreaContainer area="moreInfo"  style={null} extraClass={null}>
            <div className={styles.UpdatedWrapper}>
                <h2 className={globalStyles.subTitleText}>More Information</h2>

                <div className={styles.innerWrapper}>
                    <a href={website} target="_blank" className={styles.buttons}>
                        <div className={styles.iconRed}>
                            <img
                                alt={'website'}
                                src={"/icons/world.svg"}
                            />
                        </div>
                        <div className={styles.heading}>
                            Website
                        </div>
                    </a>
                </div>
            </div>
        </AreaContainer>
    )
}


export default MoreInfo;